module.exports = __webpack_public_path__ + "static/media/camera.1bc759e8.png";